module.exports = __webpack_public_path__ + "img/bottom_be.e531bade.png";